import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

const ExitIntentPopup = () => {
  const [open, setOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [timeoutPassed, setTimeoutPassed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile/tablet
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024 || 'ontouchstart' in window);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Set timeout for 60 seconds
    const timer = setTimeout(() => {
      setTimeoutPassed(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isMobile) {
      // For mobile devices, track scroll position
      const handleScroll = () => {
        if (!hasShown && timeoutPassed) {
          const scrolled = window.scrollY;
          const viewportHeight = window.innerHeight;
          const totalHeight = document.documentElement.scrollHeight;
          
          // Show popup when user has scrolled 50% of the page
          if (scrolled > (totalHeight - viewportHeight) * 0.5) {
            setOpen(true);
            setHasShown(true);
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    } else {
      // For desktop, use mouse movement detection
      const handleMouseMovement = (e) => {
        if (!hasShown && timeoutPassed && e.clientY < 50 && e.clientX < 50) {
          setOpen(true);
          setHasShown(true);
        }
      };

      document.addEventListener('mousemove', handleMouseMovement);
      return () => document.removeEventListener('mousemove', handleMouseMovement);
    }
  }, [hasShown, timeoutPassed, isMobile]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', color: 'primary.main' }}>
        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
          Exclusive Business Package – First Mover Advantage
        </Typography>
        <Typography variant="h5" color="secondary.main" sx={{ fontWeight: 'bold' }}>
          $995.00
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" paragraph>
          Unlock the full potential of your business with our premium Business Package, 
          now at an unbeatable price of $995 (originally $1,995)! This comprehensive package 
          offers everything you need to elevate your business operations, marketing, and growth strategies.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>
          What's Included:
        </Typography>
        <List>
          {[
            'Strategic business consultations',
            'Custom marketing plans',
            'Access to exclusive tools & resources'
          ].map((item, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon>
                <CheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Box sx={{ mt: 3, bgcolor: 'primary.light', p: 2, borderRadius: 1 }}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            Limited Time Offer:
          </Typography>
          <Typography variant="body1" sx={{ color: 'white' }}>
            Only 24 out of 25 seats remain at this discounted price. Act fast and secure your 
            spot to gain the First Mover Advantage— a significant edge over the competition!
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', mt: 2 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => window.open('https://square.link/u/y0wXqGkc', '_blank')}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            '&:hover': {
              transform: 'translateY(-2px)',
              transition: 'transform 0.2s ease-in-out',
            }
          }}
        >
          Get Started Now
        </Button>
        <Button
          onClick={handleClose}
          sx={{ ml: 2 }}
        >
          Maybe Later
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExitIntentPopup;
